// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"232":"05e18cd0","285":"47e0bcc2","307":"64850b68","453":"874d65d5","811":"fd82347b"}[chunkId] + ".chunk.js";
};